import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'antd';
import { ConfigProvider } from 'antd-v5';
import { UserCircleIcon } from 'assets/icons';
import { FORM_FIELDS } from 'pages/MyNetworkPage/GarageDetails/GarageDetails.constants';
import { GarageDetailsHeaderProps } from 'pages/MyNetworkPage/GarageDetails/GarageDetails.types';
import { antdTokenHeader, GarageBar } from 'pages/MyNetworkPage/GarageDetails/GarageDetailsPage.styled';
import { theme } from 'styles';
import { Flex, Icon, Switch, Text } from 'UI';

export const GarageDetailsHeader: React.FC<GarageDetailsHeaderProps> = ({ garageDetails, onActiveChange, form }) => {
  const { t } = useTranslation();
  const isActive = Form.useWatch(FORM_FIELDS.ACTIVE, form) ?? false;

  return (
    <ConfigProvider theme={antdTokenHeader}>
      <GarageBar direction={'row'} gap={20} align={'center'} padding={20}>
        <Flex alignSelf={'center'} size={0}>
          <Icon IconComponent={UserCircleIcon} size={50} color={theme.color.grey55} noPointer />
        </Flex>
        <Flex direction={'column'} gap={5}>
          <Text type="heading4">
            {garageDetails?.clientType} - {garageDetails?.companyName} ({garageDetails?.countryCode})
          </Text>
          <Flex direction={'row'} gap={25}>
            <Flex direction={'column'} size={0} basis={'auto'}>
              <div>
                <Text type="base" bold color="grey35">{`${t('my_network.clients.tresor_code', 'Tresor code')}: `}</Text>
                <Text type="base" color="grey55">
                  {garageDetails?.tresorCode ?? '--'}
                </Text>
              </div>
              {garageDetails?.dmsCode && (
                <div>
                  <Text type="base" bold color="grey35">{`${t('my_network.clients.dms_code', 'DMS code')}: `}</Text>
                  <Text type="base" color="grey55">
                    {garageDetails?.dmsCode ?? '--'}
                  </Text>
                </div>
              )}
            </Flex>
            <Flex direction={'column'} size={0} basis={'auto'} justify={'flex-end'}>
              {garageDetails?.birCode && (
                <div>
                  <Text type="base" bold color="grey35">{`${t('my_network.clients.bir_code', 'BIR code')}: `}</Text>
                  <Text type="base" color="grey55">
                    {garageDetails?.birCode ?? '--'}
                  </Text>
                </div>
              )}
              <div>
                <Text type="base" bold color="grey35">
                  {`${t('my_network.clients.establishment_number', 'Establishment number')}: `}
                </Text>
                <Text type="base" color="grey55">
                  {garageDetails?.establishmentNumber ?? '--'}
                </Text>
              </div>
            </Flex>
          </Flex>
        </Flex>
        <Flex direction={'row'} gap={20} size={0} align={'center'} justify={'flex-end'} minWidth={200}>
          <Text type={'text'}>
            {isActive
              ? t('my_network.garage_details.deactivate_client', 'Disable client')
              : t('my_network.garage_details.activate_client', 'Activate client')}
          </Text>
          <Form form={form}>
            <Form.Item name={FORM_FIELDS.ACTIVE} valuePropName="checked">
              <Switch onChange={onActiveChange} />
            </Form.Item>
          </Form>
        </Flex>
      </GarageBar>
    </ConfigProvider>
  );
};
